import { keyed } from "@/lib/keys";

function parse(text = "") {
  const blocks = [];
  let list = null;
  text.split("\n").forEach((raw) => {
    const line = raw.trim();
    if (line.startsWith("- ")) {
      if (!list) blocks.push((list = { type: "ul", items: [] }));
      list.items.push(line.slice(2));
      return;
    }
    list = null;
    if (!line) return;
    if (line.startsWith("## ")) blocks.push({ type: "h2", text: line.slice(3) });
    else blocks.push({ type: "p", text: line });
  });
  return blocks;
}

const blockText = (b) => `${b.type}:${b.text ?? b.items.join("|")}`;

const Block = ({ b }) => {
  if (b.type === "h2") return <h2 className="mb-3 mt-10 text-xl font-bold text-brand-ink first:mt-0 md:text-2xl">{b.text}</h2>;
  if (b.type === "ul") {
    return (
      <ul className="mb-5 list-disc space-y-2 pl-6 text-base leading-relaxed text-slate-700 marker:text-brand-green">
        {keyed(b.items).map(([k, it]) => <li key={k}>{it}</li>)}
      </ul>
    );
  }
  return <p className="mb-4 text-base leading-relaxed text-slate-700">{b.text}</p>;
};

export const RichText = ({ text, className = "" }) => (
  <div className={className}>
    {keyed(parse(text), blockText).map(([k, b]) => <Block key={k} b={b} />)}
  </div>
);
